/**
 * View component for /user-nodes/new
 *
 * Creates a new userNode from a copy of the defaultItem in the userNode reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userNodeActions from '../userNodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userNode components
import UserNodeForm from '../components/UserNodeForm.js.jsx';
import UserNodeLayout from '../components/UserNodeLayout.js.jsx';

class CreateUserNode extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userNode: _.cloneDeep(this.props.defaultUserNode)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newUserNodeState = _.update( this.state.userNode, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userNode :newUserNodeState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userNodeActions.sendCreateUserNode(this.state.userNode)).then((action) => {
      if(action.success) {
        dispatch(userNodeActions.invalidateList());
        history.push(`/user-nodes/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { userNode } = this.state;
    const isEmpty = (userNode.name === null || userNode.name === undefined);
    return (
      <UserNodeLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <UserNodeForm
                userNode={userNode}
                cancelLink="/user-nodes"
                formTitle="Create User Node"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </UserNodeLayout>
    )
  }
}

CreateUserNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUserNode: store.userNode.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateUserNode)
);



// WEBPACK FOOTER //
// modules/userNode/views/CreateUserNode.js.jsx